var ingredientItems = document.getElementsByClassName("product-ingredient-item");
var ingredientImages = document.getElementsByClassName("product-ingredient-image");

function clearIngredientItemsActive() {
    Array.prototype.forEach.call(ingredientItems, function (el) {
        el.classList.remove("active");
    });

    Array.prototype.forEach.call(ingredientImages, function (el) {
        el.classList.remove("active");
    });
}

function ingredientItemClick(elm, index) {
    clearIngredientItemsActive();
    elm.classList.add("active");
    ingredientImages[index].classList.add("active");
}

Array.prototype.forEach.call(ingredientItems, function (el, index) {
    el.addEventListener("click", function () {
        ingredientItemClick(this, index);
    });
});

new Swiper(".swiper-featured-collection-products", {
    slidesPerView: 2,
    spaceBetween: 30,
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    // scrollbar: {
    //   el: ".swiper-scrollbar",
    //   hide: true,
    // },
    breakpoints: {
        990: {
            slidesPerView: 3,
        },
    },
});

new Swiper(".swiper-featured-collection-best", {
    slidesPerView: 2,
    spaceBetween: 27,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        990: {
            slidesPerView: 4,
        },
    },
});

window.addEventListener("load", function () {
    var tabButtons = document.querySelectorAll(".tabs__pills .btn--tabs");
    var tabContents = document.querySelectorAll(".tabs__panels > div");
    var tabContainer = document.querySelector(".ritual-steps__content-wrapper");
    if (tabButtons && tabContents) {
        // tabContainer.addEventListener("click", (e) => {
        //     var activeButton = document.querySelectorAll(".ritual-steps__number.active");
        //     if (activeButton.length > 0) {
        //         activeButton[0].click();
        //     }
        // });
        tabButtons.forEach((tabBtn) => {
            tabBtn.addEventListener("click", () => {
                var tabId = tabBtn.getAttribute("data-id");

                tabButtons.forEach((btn) => btn.classList.remove("active"));
                tabBtn.classList.add("active");

                tabContents.forEach((content) => {
                    content.classList.remove("active");

                    if (content.id === tabId) {
                        content.classList.add("active");
                    }
                });
            });
        });
    }
});

const ritualStepsContent = new Swiper(".ritual-steps__content", {
    allowTouchMove: false,
});
const ritualStepsImage = new Swiper(".ritual-steps__image", {
    allowTouchMove: false,
});

const steps = document.getElementsByClassName("ritual-steps__steps");
Array.from(steps).forEach((elm) => {
    const numbers = elm.getElementsByClassName("ritual-steps__number");

    function cleanNumbers() {
        Array.from(numbers).forEach((numbElm) => {
            numbElm.classList.remove("active");
        });
    }

    Array.from(numbers).forEach((numbElm, index) => {
        let isHover = false;
        numbElm.addEventListener("mouseover", () => {
            if (!isHover) {
                //console.log("__testing12");
                cleanNumbers();
                numbElm.classList.add("active");
                isHover = true;
                ritualStepsContent.slideTo(index);
                ritualStepsImage.slideTo(index);
            }
        });
        numbElm.addEventListener("mouseover", () => {
            isHover = false;
        });
    });
});
